import { useQuery } from "@tanstack/react-query";
import { fetchUserCoinsHistory } from "../services/gamificationService";

function normalizePagination(pagination = {}, requestedPage = 1, totalRecords = 0) {
  return {
    currentPage: Number(pagination?.currentPage || pagination?.current_page || requestedPage || 1),
    totalPages: Number(pagination?.totalPages || pagination?.total_pages || 1),
    totalRecords: Number(pagination?.totalRecords || pagination?.total_records || totalRecords || 0),
  };
}

function normalizeHistoryItem(item, index) {
  const type = String(item?.type || "added").trim().toLowerCase();
  const normalizedCoins = Math.abs(Number(item?.coins || 0));
  const isNegative =
    type === "deduct" ||
    type === "deducted" ||
    type === "subtracted" ||
    type === "spent" ||
    type === "removed";

  return {
    id: `${item?.created_at || "history"}-${index}`,
    activity: item?.activity || "Coin activity",
    createdAt: item?.created_at || "-",
    type,
    coins: normalizedCoins,
    signedCoins: `${isNegative ? "-" : "+"}${normalizedCoins}`,
    isNegative,
    raw: item,
  };
}

export function useUserCoinsHistory(params = {}, options = {}) {
  return useQuery({
    queryKey: ["userCoinsHistory", params],
    queryFn: async () => {
      const { payload } = await fetchUserCoinsHistory(params);
      const rawHistory = Array.isArray(payload?.coins_history) ? payload.coins_history : [];
      const pagination = normalizePagination(payload?.pagination || {}, params?.page, rawHistory.length);

      return {
        currentCoins: Number(payload?.current_coins || 0),
        history: rawHistory.map(normalizeHistoryItem),
        pagination,
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        currentCoins: 0,
        history: [],
        pagination: {
          currentPage: Number(params?.page || 1),
          totalPages: 1,
          totalRecords: 0,
        },
      },
  });
}
